import styles from "./AdaptFilters.module.css"
import { useState, useEffect, useRef } from "react";
import Toggle from "../Forms/Toggle"
import Filters from "../Filters/Filters"
import { filterssvg } from "../../assets/svg/svgimages";

const AdaptFilters = ({
  selected,
  manufacturers,
  openManufacturer,
  openCamera,
  openLensBrand,
  toggleManufacturerMenu,
  toggleCameraMenu,
  toggleLensBrandMenu,
  handleCameraSelect,
  handleLensBrandSelect,
  handleLensSeriesSelect,
  handleSearch,
  search,
  activeFilterCount = 0,
  onResetFilters,
  onBeforeAvailabilityChange,
}) => {

    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const containerRef = useRef(null);

    const toggleFilters = () => {
        setFiltersOpen(!filtersOpen);
      };

    // Закрытие фильтра по клику вне его области
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          filtersOpen &&
          containerRef.current &&
          !containerRef.current.contains(event.target)
        ) {
          setFiltersOpen(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('touchstart', handleClickOutside);
      };
    }, [filtersOpen]);

    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 1200);
      };
      handleResize();
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    
  return (
    <div ref={containerRef} className={styles.main}>
      <button className={styles.btn} type="button" onClick={toggleFilters}>
        <span className={styles.btnLabel}>Filters</span>
        <span className={styles.btnMeta}>
          {activeFilterCount > 0 && (
            <span className={styles.countBadge}>{activeFilterCount}</span>
          )}
          <span className={styles.btnIcon}>{filterssvg}</span>
        </span>
      </button>
      <div
        className={`${styles.filtersmenu} ${
          isSmallScreen && filtersOpen ? styles.filtersmenuOpen : ""
        }`}
      >
        {(isSmallScreen && filtersOpen) && (
          <Filters
            manufacturers={manufacturers}
            selected={selected}
            openManufacturer={openManufacturer}
            openCamera={openCamera}
            openLensBrand={openLensBrand}
            toggleManufacturerMenu={toggleManufacturerMenu}
            toggleCameraMenu={toggleCameraMenu}
            toggleLensBrandMenu={toggleLensBrandMenu}
            handleCameraSelect={handleCameraSelect}
            handleLensBrandSelect={handleLensBrandSelect}
            handleLensSeriesSelect={handleLensSeriesSelect}
            handleSearch={handleSearch}
            search={search}
            activeFilterCount={activeFilterCount}
            onResetFilters={onResetFilters}
          />
        )}
      </div>
      <div className={styles.togglewrap}>
        <Toggle
          variant="segmented"
          label="Availability filter"
          onBeforeChange={onBeforeAvailabilityChange}
        />
      </div>
    </div>
  );
};

export default AdaptFilters
